<template>
  <v-bottom-navigation fixed v-model="bottomNav">
    <v-btn value="lists" to="/home">
      <span>My lists</span>
      <v-icon>mdi-format-list-bulleted</v-icon>
    </v-btn>

    <!-- <v-btn value="products" to="/products">
      <span>Products</span>
      <v-icon>mdi-briefcase</v-icon>
    </v-btn> -->

    <!-- <v-btn value="recipes" to="/recipes">
      <span>Recipes</span>
      <v-icon>mdi-food-variant</v-icon>
    </v-btn> -->

    <v-btn value="logout" @click="logout">
      <span>Log out</span>
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
const fb = require("../firebaseConfig.js");
import firebase from "firebase";
import { mapState } from "vuex";

export default {
  data() {
    return {
      bottomNav: "lists"
    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  methods: {
    logout() {
      fb.usersCollection
        .doc(this.currentUser.uid)
        .update({
          FCMToken: firebase.firestore.FieldValue.delete()
        })
        .then(() => {
          fb.auth
            .signOut()
            .then(() => {
              this.$store.dispatch("clearData");
              this.$router.push("/login");
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss">
#nav {
  margin: 0 auto;
  padding: 10px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#mainNavList {
  li {
    display: inline-block;
    padding: 0 25px 0 25px;
  }
}
</style>
